import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import MainContainer from "./MainContainer";


ReactDOM.render((
  <div>
    <MainContainer />
  </div>
), document.getElementById("root"))



// WEBPACK FOOTER //
// ./src/index.js